import React from "react";
import PropTypes from "prop-types";

import "./ProgressBar.scss";

const ProgressBar = ({
  current,
  total,
  percent = false,
  minValue = 0,
  maxValue = 100,
  labelAddon = "",
  answeredRemaining,
  showNumbersReport = false,
  showIncomplete = false,
}) => {
  const percentDone = Math.ceil((current * 100) / total);
  const isComplete = current === total;

  let labelString = percent ? `${percentDone}%` : `${current} of ${total}`;

  labelString = labelAddon ? `${labelString} ${labelAddon}` : labelString;

  if (isComplete && !showNumbersReport) {
    labelString = "Completed";
  }

  if (showIncomplete) {
    labelString = "Incomplete";
  }

  return (
    <div className={`progress-container ${isComplete ? "complete" : ""}`}>
      <div className="text-small text-strong pb-1">
        <span>{answeredRemaining || labelString}</span>
        {answeredRemaining && (
          <div>
            <span className="fw-bold">{current} </span>
            {` / ${total}`}
          </div>
        )}
      </div>
      <div className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          aria-valuenow={current}
          aria-valuemin={minValue}
          aria-valuemax={maxValue}
          style={{ width: `${percentDone}%` }}
        />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  percent: PropTypes.bool,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  labelAddon: PropTypes.string,
  answeredRemaining: PropTypes.string,
  showNumbersReport: PropTypes.bool,
  showIncomplete: PropTypes.bool,
};

export default ProgressBar;
